<template>
  <video class="header-video" autoplay muted loop>
    <source src="../../assets/header.mp4" type="video/mp4" />
  </video>
</template>

<script>
export default {
  name: 'HeaderBackground',
};
</script>

<style scoped>
.header-video {
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  filter: brightness(105.5%);
}

@media screen and (max-width: 797px) {
  .header-video {
    width: auto;
    min-height: 55%;
    max-height: 55%;
    top: 0;
    left: 40%;
    transform: translate(-50%, 0);
    min-height: initial;
  }
}
</style>
